import {
  addUniqueValueToArray
} from 'utils/redux'

export const NAMESPACE = 'KanBo/Home/layoutGroups/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const REMOVE_BOARD_FROM_ALL = NAMESPACE + 'REMOVE_BOARD_FROM_ALL'
export const ADD_ELEMENT = NAMESPACE + 'ADD_ELEMENT'
export const SET_ELEMENT = NAMESPACE + 'SET_ELEMENT'
export const REMOVE_ELEMENT = NAMESPACE + 'REMOVE_ELEMENT'
export const SET_NAME = NAMESPACE + 'SET_NAME'
export const POSITION_ELEMENT = NAMESPACE + 'POSITION_ELEMENT'

const initialState = { }

const layoutGroupDefaults = {
  elements: []
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case ADD:
      return {
        ...state,
        [action.payload.key]: {
          ...layoutGroupDefaults,
          ...state[action.payload.key],
          ...action.payload
        }
      }
    case ADD_ARRAY: {
      const newState = {
        ...state
      }
      action.payload.forEach(layoutGroup => {
        newState[layoutGroup.key] = {
          ...layoutGroupDefaults,
          ...state[layoutGroup.key],
          ...layoutGroup
        }
      })
      return newState
    }
    case REMOVE: {
      const newState = {
        ...state
      }
      delete newState[action.payload.id]
      return newState
    }
    case ADD_ELEMENT:
      return {
        ...state,
        [action.payload.key]: {
          ...state[action.payload.key],
          elements: addUniqueValueToArray({
            array: state[action.payload.key].elements.filter(element => element.id !== action.payload.elementId),
            value: {
              id: action.payload.elementId,
              ...action.payload.data
            },
            index: action.payload.position
          })
        }
      }
    case SET_ELEMENT: {
      const newState = { ...state }
      let elementFound = false

      Object.keys(newState).forEach(key => {
        if (
          key.indexOf(action.payload.layoutId.toString()) === -1 ||
          elementFound
        ) return

        const element = newState[key].elements.find(element => element.id === action.payload.elementId)

        if (element) {
          elementFound = true

          newState[key] = {
            ...newState[key],
            elements: addUniqueValueToArray({
              array: newState[key].elements.filter(element => element.id !== action.payload.elementId),
              value: {
                ...element,
                ...action.payload.data
              },
              index: newState[key].elements.indexOf(element)
            })
          }
        }
      })

      return elementFound ? newState : state
    }
    case REMOVE_ELEMENT:
      return {
        ...state,
        [action.payload.key]: {
          ...state[action.payload.key],
          elements: [
            ...state[action.payload.key].elements.filter(element => element.id !== action.payload.elementId)
          ]
        }
      }
    case REMOVE_BOARD_FROM_ALL: {
      const newState = { ...state }

      Object.keys(newState).forEach(key => {
        const _element = newState[key].elements.find(element =>
          element.type === 'board' &&
          element.boardId === action.payload.boardId
        )

        if (_element) {
          newState[key] = {
            ...newState[key],
            elements: newState[key].elements.filter(element =>
              element.type !== 'board' ||
              element.boardId !== action.payload.boardId
            )
          }
        }
      })

      return newState
    }
    case SET_NAME:
      return state[action.payload.key] ? {
        ...state,
        [action.payload.key]: {
          ...state[action.payload.key],
          name: action.payload.name
        }
      } : state
    case POSITION_ELEMENT: {
      const newState = { ...state }
      let element = null

      Object.keys(newState).forEach(key => {
        if (
          key.indexOf(action.payload.layoutId.toString()) === -1 ||
          element
        ) return

        const _element = newState[key].elements.find(element => element.id === action.payload.elementId)

        if (_element) {
          newState[key] = {
            ...newState[key],
            elements: newState[key].elements.filter(element => element.id !== action.payload.elementId)
          }

          element = _element
        }
      })

      const key = `${action.payload.layoutId}-${action.payload.groupId}`

      if (element) {
        newState[key] = {
          ...newState[key],
          elements: addUniqueValueToArray({
            array: newState[key].elements,
            value: {
              ...element
            },
            index: action.payload.position
          })
        }
      }

      return newState
    }
    default: return state
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (array) {
  return {
    type: ADD_ARRAY,
    payload: array
  }
}

export function remove ({ key }) {
  return {
    type: REMOVE,
    payload: {
      key
    }
  }
}

export function addElement ({ key, elementId, position, ...data }) {
  return {
    type: ADD_ELEMENT,
    payload: {
      key,
      elementId,
      position,
      data
    }
  }
}

export function setElement ({ layoutId, elementId, ...data }) {
  return {
    type: SET_ELEMENT,
    payload: {
      layoutId,
      elementId,
      data
    }
  }
}

export function removeElement ({ key, elementId }) {
  return {
    type: REMOVE_ELEMENT,
    payload: {
      key,
      elementId
    }
  }
}

export function removeBoardFromAll ({ boardId }) {
  return {
    type: REMOVE_BOARD_FROM_ALL,
    payload: {
      boardId
    }
  }
}

export function setName ({ key, name }) {
  return {
    type: SET_NAME,
    payload: {
      key,
      name
    }
  }
}

export function positionElement ({ layoutId, groupId, elementId, position }) {
  return {
    type: POSITION_ELEMENT,
    payload: {
      layoutId,
      groupId,
      elementId,
      position
    }
  }
}
